module.exports = __webpack_public_path__ + "static/media/yui-hatano-win.12e502bb.jpg";